import { IFaireMoney } from "@faire/web-api/indigofair/data/IFaireMoney";
import { StrictLocalizeFunction } from "@faire/web/common/localization";
import { formatMoney, RoundingStrategy } from "@faire/web/common/money";

export const getOrderMinimum = (
  isFirstOrder: boolean | undefined,
  minimumOrderAmount: IFaireMoney | undefined,
  strictLocalize: StrictLocalizeFunction
) => {
  if (minimumOrderAmount === undefined) {
    return "";
  }

  const minimunOrderAmountMoney = formatMoney({
    money: minimumOrderAmount,
    roundingStrategy: RoundingStrategy.DROP_CENTS_ROUND_UP,
  });

  if (isFirstOrder) {
    return strictLocalize(
      {
        defaultMessage: "{minimunOrderAmountMoney} min",
        description: {
          text: "The amount of a minimum order",
          img: "https://cdn.faire.com/fastly/e4431dc743ff98ca85126b8e73fd8f48ce0eb8b02c82e3d381be03830b9ae908.png",
        },
      },
      { minimunOrderAmountMoney }
    );
  }

  return strictLocalize(
    {
      defaultMessage: "{minimunOrderAmountMoney} reorder",
      description: {
        text: "The minimum amount of a reorder ",
        img: "https://cdn.faire.com/fastly/82b29d9038b0f2993e91b11851e67061066cc6250bab94dab6f2eaf8a9cf9d3c.png",
      },
    },
    { minimunOrderAmountMoney }
  );
};
